export const condition = fn =>
  fn === undefined || (typeof fn === 'function' && fn()) || fn;
